import { defineSlotRecipe } from "@chakra-ui/react";

export const choiceSlotRecipe = defineSlotRecipe({
    slots: ["root"],
    base: {
        root: { colorPalette: "blue" },
    },
});
